module.exports = __webpack_public_path__ + "static/media/sibsiu.44daff21.png";